module.exports = __webpack_public_path__ + "media/images/double_arrow-ceacb5f2166892f367c37e2cc274516a.svg";